import { TFunction } from 'i18next';
import { TaskCreationException } from '../interface/common';

export enum TaskErrorField {
  MATTER = 'matter',
}

export interface ITaskFieldError {
  field: TaskErrorField;
  message: string;
}

export function getTaskCreationFieldError(
  t: TFunction,
  apiErrorType?: string,
): ITaskFieldError | null {
  if (apiErrorType === TaskCreationException.CannotLinkToClosedMatterException) {
    return {
      field: TaskErrorField.MATTER,
      message: t('transaction:error.matterIsClosed'),
    };
  }

  return null;
}
